// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoItem_container__2kr1L","header":"InfoItem_header__3jhC9","content":"InfoItem_content__3o0Nn"};